import CryptoJS from 'crypto-js'

const key = '235325fdgerteGHdsfsdewred4345341'
const iv = '4387438hfdhfdjhg'

// 加密
export const encrypt = data => {
    return CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString()

    // return data
}

// 解密
export const decrypt = data => {
    let decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)

    // return data
}
